<div
  class="course-selection-card"
  [class.course-selection-card--selected]="selected()"
  (click)="selectOption()"
  (keydown.enter)="selectOption()"
  (keydown.space)="selectOption(); $event.preventDefault()"
  tabindex="0"
  role="radio"
  [attr.aria-checked]="selected()"
  [attr.aria-label]="title()"
>
  <!-- Header: Title -->
  <div class="course-selection-card__header">
    <h3 class="course-selection-card__title">{{ title() }}</h3>
  </div>

  <!-- Footer: Subtitle (left) + Radio button (right) on same row -->
  <div class="course-selection-card__footer">
    @if (subtitle()) {
    <span class="course-selection-card__subtitle">{{ subtitle() }}</span>
    }
    <div class="course-selection-card__radio">
      <input type="radio" [checked]="selected()" tabindex="-1" aria-hidden="true" />
    </div>
  </div>
</div>
